<script lang="ts" setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCategoryStore } from '@/stores/category';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const $props = defineProps<{
  modelValue?: string[];
}>();

const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);
const categoryStore = useCategoryStore();
const { sortedList: categories } = storeToRefs(categoryStore);
const value = ref($props.modelValue || []);

const handleChange = () => {
  $emit('change', value.value);
  $emit('update:value', value.value);
  $emit('update:modelValue', value.value);
};
</script>

<template>
  <el-select v-model="value" @change="handleChange" multiple collapse-tags :placeholder="t('product_menu.form.categories.description')">
    <el-option v-for="item in categories" :key="item.uid" :label="item.name_translations?.[locale] || item.name" :value="item.uid"></el-option>
  </el-select>
</template>
